import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'comp-datetime-location',
  templateUrl: 'datetime-location.html',
})
export class DatetimeLocationPage {
  @Input() display; //date - time - datetime
  @Input() location:any='es'; //es - en
  @Input() date; //.toDate()

  constructor(public navCtrl: NavController,
    public navParams: NavParams, 
    public globals: Globals) {
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/datetime-location/datetime-location.ts